import React from 'react'
import { makeStyles } from '@material-ui/core'
import SectionScreen from '../../SectionScreen'
import { useClientDetails } from '../../ClientDetailsFormContext'
import { useGetClientAccountGroupHierarchy } from '../../../../../../api/groups'
import SectionHeader from '../../../shared/SectionHeader'
import FadeIn from '../../../../../molecules/Transitions/FadeIn'
import Hierarchy from './Hierarchy'

const useStyles = makeStyles((theme) => ({
  tagsSection: {
    position: 'relative',
    padding: '10px'
  }
}))

function ClientAccountGroups () {
  const classes = useStyles()
  const { client } = useClientDetails()
  const { data, isLoading } = useGetClientAccountGroupHierarchy(client.clientId)

  if (isLoading) {
    return null
  }

  return (
    <FadeIn>
      <SectionScreen sectionName='client-specific-groups' className={classes.tagsSection}>
        <SectionHeader text='Client-Account Tags' />
        <div>
          <Hierarchy client={client} groupTypes={data.groupTypes} />
        </div>
      </SectionScreen>
    </FadeIn>
  )
}

export default ClientAccountGroups
